<template>
  <div class="w-100" style="padding: -1rem">
    <div class="d-flex align-items-center justify-content-center col-12">
      <h1>{{title}}</h1>
    </div>
    <div class="text-center">
      <div class="inside__box py-4 px-2 h-100" v-for="(data, index) in dataList">
        <div class="inside__text__box">
          <h2>{{data.titleH2}}</h2>
          <p class="px-2 text-left">{{data.contentP}}</p>
          <div class="d-flex justify-content-center">
            <a class="btn btn-sm btn-outline-primary" :href="data.buttonUrl">
              {{data.buttonName}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    props: {
      title: {
        type: String
      },
      dataList: {
        type: Array
      }
    },
  };

</script>

<style lang="scss">
  .inside__box {
    margin: 1rem auto;
    display: inline-block;
    width: 100%;
    min-width: 160px;
    max-width: 320px;
    vertical-align: top;
    text-align: left;

    .inside__text__box {
      padding: 20px 10px;
      border: 1px solid #aaaaaa;
    }
  }

</style>
